module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 4);
}([function (e, t, n) {
  e.exports = n(7)();
}, function (e, t, n) {
  "use strict";

  e.exports = n(5);
}, function (e, t, n) {
  "use strict";

  var r = Array.isArray,
      o = Object.keys,
      a = Object.prototype.hasOwnProperty;

  e.exports = function e(t, n) {
    if (t === n) return !0;

    if (t && n && "object" == typeof t && "object" == typeof n) {
      var i,
          u,
          s,
          c = r(t),
          l = r(n);

      if (c && l) {
        if ((u = t.length) != n.length) return !1;

        for (i = u; 0 != i--;) {
          if (!e(t[i], n[i])) return !1;
        }

        return !0;
      }

      if (c != l) return !1;
      var f = t instanceof Date,
          p = n instanceof Date;
      if (f != p) return !1;
      if (f && p) return t.getTime() == n.getTime();
      var d = t instanceof RegExp,
          y = n instanceof RegExp;
      if (d != y) return !1;
      if (d && y) return t.toString() == n.toString();
      var h = o(t);
      if ((u = h.length) !== o(n).length) return !1;

      for (i = u; 0 != i--;) {
        if (!a.call(n, h[i])) return !1;
      }

      for (i = u; 0 != i--;) {
        if (!e(t[s = h[i]], n[s])) return !1;
      }

      return !0;
    }

    return t != t && n != n;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      o = u(n(10)),
      a = u(n(11)),
      i = u(n(13));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = void 0;
  t.default = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        u = (0, o.default)();
    if (s || (s = (0, a.default)(u)), t.events) throw new Error("Event handlers cannot be overwritten.");
    if ("string" == typeof e && !document.getElementById(e)) throw new Error('Element "' + e + '" does not exist.');
    t.events = i.default.proxyEvents(u);
    var c = new Promise(function (n) {
      "object" === (void 0 === e ? "undefined" : r(e)) && e.playVideo instanceof Function ? n(e) : s.then(function (r) {
        var o = new r.Player(e, t);
        return u.on("ready", function () {
          n(o);
        }), null;
      });
    }),
        l = i.default.promisifyPlayer(c, n);
    return l.on = u.on, l.off = u.off, l;
  }, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var r = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      o = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      a = c(n(1)),
      i = c(n(0)),
      u = c(n(9)),
      s = c(n(22));

  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var l = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
          r = n.props.aspectRatio.split(":");

      return n.state = {
        aspectRatio: r[0] / r[1],
        videoHeight: 10
      }, n.defaultPlayerVars = {
        autoplay: 1,
        controls: 0,
        rel: 0,
        showinfo: 0,
        mute: 1,
        modestbranding: 1,
        iv_load_policy: 3,
        playsinline: 1
      }, n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), o(t, [{
      key: "componentDidMount",
      value: function value() {
        this.updateDimensions(), window.addEventListener("resize", this.updateDimensions.bind(this));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
      }
    }, {
      key: "updateDimensions",
      value: function value() {
        var e = this.state.aspectRatio,
            t = this.container.clientWidth,
            n = this.container.clientHeight,
            r = n,
            o = t,
            a = 0,
            i = 0;
        t / n > e ? a = ((r = t / e) - n) / -2 : i = ((o = n * e) - t) / -2, this.setState({
          videoHeight: r,
          videoWidth: o,
          videoY: a,
          videoX: i
        });
      }
    }, {
      key: "onEnd",
      value: function value(e) {
        e.target.playVideo(), this.props.onEnd(e);
      }
    }, {
      key: "onReady",
      value: function value(e) {
        e.target.playVideo(), this.props.onReady(e);
      }
    }, {
      key: "render",
      value: function value() {
        var e,
            t = this,
            n = this.state,
            o = n.videoHeight,
            i = n.videoWidth,
            c = n.videoX,
            l = n.videoY,
            f = this.props,
            p = f.style,
            d = f.children,
            y = f.className,
            h = f.overlay,
            v = f.playerOptions,
            m = {
          videoId: (e = this.props).videoId,
          onPlay: e.onPlay,
          onPause: e.onPause,
          onError: e.onError,
          onStateChange: e.onStateChange,
          onPlaybackRateChange: e.onPlaybackRateChange,
          onPlaybackQualityChange: e.onPlaybackQualityChange
        },
            b = {
          playerVars: r({}, this.defaultPlayerVars, v),
          host: this.props.nocookie ? "https://www.youtube-nocookie.com" : "https://www.youtube.com"
        };
        return a.default.createElement("div", {
          style: p,
          ref: function ref(e) {
            return t.container = e;
          },
          className: [s.default.container, y].join(" ")
        }, a.default.createElement("div", null, d), a.default.createElement("div", {
          className: s.default.videoContainer,
          style: {
            width: i + "px",
            height: o + "px",
            top: l + "px",
            left: c + "px"
          }
        }, h && a.default.createElement("div", {
          className: s.default.overlay,
          style: {
            backgroundColor: h
          }
        }), a.default.createElement(u.default, r({}, m, {
          onReady: this.onReady.bind(this),
          onEnd: this.onEnd.bind(this),
          opts: b,
          className: s.default.videoIframe,
          containerClassName: s.default.videoInnerContainer
        }))));
      }
    }]), t;
  }(a.default.Component);

  l.propTypes = {
    videoId: i.default.string.isRequired,
    aspectRatio: i.default.string,
    overlay: i.default.string,
    className: i.default.string,
    onReady: i.default.func,
    onEnd: i.default.func,
    playerOptions: i.default.object
  }, l.defaultProps = {
    aspectRatio: "16:9",
    overlay: "false",
    nocookie: !1,
    playerOptions: {},
    onReady: function onReady() {},
    onPlay: function onPlay() {},
    onPause: function onPause() {},
    onError: function onError() {},
    onEnd: function onEnd() {}
  }, t.default = l;
}, function (e, t, n) {
  "use strict";
  /** @license React v16.13.1
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var r = n(6),
      o = "function" == typeof Symbol && Symbol.for,
      a = o ? Symbol.for("react.element") : 60103,
      i = o ? Symbol.for("react.portal") : 60106,
      u = o ? Symbol.for("react.fragment") : 60107,
      s = o ? Symbol.for("react.strict_mode") : 60108,
      c = o ? Symbol.for("react.profiler") : 60114,
      l = o ? Symbol.for("react.provider") : 60109,
      f = o ? Symbol.for("react.context") : 60110,
      p = o ? Symbol.for("react.forward_ref") : 60112,
      d = o ? Symbol.for("react.suspense") : 60113,
      y = o ? Symbol.for("react.memo") : 60115,
      h = o ? Symbol.for("react.lazy") : 60116,
      v = "function" == typeof Symbol && Symbol.iterator;

  function m(e) {
    for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) {
      t += "&args[]=" + encodeURIComponent(arguments[n]);
    }

    return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }

  var b = {
    isMounted: function isMounted() {
      return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
  },
      g = {};

  function w(e, t, n) {
    this.props = e, this.context = t, this.refs = g, this.updater = n || b;
  }

  function P() {}

  function _(e, t, n) {
    this.props = e, this.context = t, this.refs = g, this.updater = n || b;
  }

  w.prototype.isReactComponent = {}, w.prototype.setState = function (e, t) {
    if ("object" != typeof e && "function" != typeof e && null != e) throw Error(m(85));
    this.updater.enqueueSetState(this, e, t, "setState");
  }, w.prototype.forceUpdate = function (e) {
    this.updater.enqueueForceUpdate(this, e, "forceUpdate");
  }, P.prototype = w.prototype;
  var E = _.prototype = new P();
  E.constructor = _, r(E, w.prototype), E.isPureReactComponent = !0;
  var S = {
    current: null
  },
      C = Object.prototype.hasOwnProperty,
      O = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function x(e, t, n) {
    var r,
        o = {},
        i = null,
        u = null;
    if (null != t) for (r in void 0 !== t.ref && (u = t.ref), void 0 !== t.key && (i = "" + t.key), t) {
      C.call(t, r) && !O.hasOwnProperty(r) && (o[r] = t[r]);
    }
    var s = arguments.length - 2;
    if (1 === s) o.children = n;else if (1 < s) {
      for (var c = Array(s), l = 0; l < s; l++) {
        c[l] = arguments[l + 2];
      }

      o.children = c;
    }
    if (e && e.defaultProps) for (r in s = e.defaultProps) {
      void 0 === o[r] && (o[r] = s[r]);
    }
    return {
      $$typeof: a,
      type: e,
      key: i,
      ref: u,
      props: o,
      _owner: S.current
    };
  }

  function k(e) {
    return "object" == typeof e && null !== e && e.$$typeof === a;
  }

  var j = /\/+/g,
      R = [];

  function T(e, t, n, r) {
    if (R.length) {
      var o = R.pop();
      return o.result = e, o.keyPrefix = t, o.func = n, o.context = r, o.count = 0, o;
    }

    return {
      result: e,
      keyPrefix: t,
      func: n,
      context: r,
      count: 0
    };
  }

  function A(e) {
    e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > R.length && R.push(e);
  }

  function I(e, t, n) {
    return null == e ? 0 : function e(t, n, r, o) {
      var u = typeof t;
      "undefined" !== u && "boolean" !== u || (t = null);
      var s = !1;
      if (null === t) s = !0;else switch (u) {
        case "string":
        case "number":
          s = !0;
          break;

        case "object":
          switch (t.$$typeof) {
            case a:
            case i:
              s = !0;
          }

      }
      if (s) return r(o, t, "" === n ? "." + N(t, 0) : n), 1;
      if (s = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for (var c = 0; c < t.length; c++) {
        var l = n + N(u = t[c], c);
        s += e(u, l, r, o);
      } else if (null === t || "object" != typeof t ? l = null : l = "function" == typeof (l = v && t[v] || t["@@iterator"]) ? l : null, "function" == typeof l) for (t = l.call(t), c = 0; !(u = t.next()).done;) {
        s += e(u = u.value, l = n + N(u, c++), r, o);
      } else if ("object" === u) throw r = "" + t, Error(m(31, "[object Object]" === r ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, ""));
      return s;
    }(e, "", t, n);
  }

  function N(e, t) {
    return "object" == typeof e && null !== e && null != e.key ? function (e) {
      var t = {
        "=": "=0",
        ":": "=2"
      };
      return "$" + ("" + e).replace(/[=:]/g, function (e) {
        return t[e];
      });
    }(e.key) : t.toString(36);
  }

  function U(e, t) {
    e.func.call(e.context, t, e.count++);
  }

  function L(e, t, n) {
    var r = e.result,
        o = e.keyPrefix;
    e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? V(e, r, n, function (e) {
      return e;
    }) : null != e && (k(e) && (e = function (e, t) {
      return {
        $$typeof: a,
        type: e.type,
        key: t,
        ref: e.ref,
        props: e.props,
        _owner: e._owner
      };
    }(e, o + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(j, "$&/") + "/") + n)), r.push(e));
  }

  function V(e, t, n, r, o) {
    var a = "";
    null != n && (a = ("" + n).replace(j, "$&/") + "/"), I(e, L, t = T(t, a, r, o)), A(t);
  }

  var D = {
    current: null
  };

  function M() {
    var e = D.current;
    if (null === e) throw Error(m(321));
    return e;
  }

  var $ = {
    ReactCurrentDispatcher: D,
    ReactCurrentBatchConfig: {
      suspense: null
    },
    ReactCurrentOwner: S,
    IsSomeRendererActing: {
      current: !1
    },
    assign: r
  };
  t.Children = {
    map: function map(e, t, n) {
      if (null == e) return e;
      var r = [];
      return V(e, r, null, t, n), r;
    },
    forEach: function forEach(e, t, n) {
      if (null == e) return e;
      I(e, U, t = T(null, null, t, n)), A(t);
    },
    count: function count(e) {
      return I(e, function () {
        return null;
      }, null);
    },
    toArray: function toArray(e) {
      var t = [];
      return V(e, t, null, function (e) {
        return e;
      }), t;
    },
    only: function only(e) {
      if (!k(e)) throw Error(m(143));
      return e;
    }
  }, t.Component = w, t.Fragment = u, t.Profiler = c, t.PureComponent = _, t.StrictMode = s, t.Suspense = d, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $, t.cloneElement = function (e, t, n) {
    if (null == e) throw Error(m(267, e));
    var o = r({}, e.props),
        i = e.key,
        u = e.ref,
        s = e._owner;

    if (null != t) {
      if (void 0 !== t.ref && (u = t.ref, s = S.current), void 0 !== t.key && (i = "" + t.key), e.type && e.type.defaultProps) var c = e.type.defaultProps;

      for (l in t) {
        C.call(t, l) && !O.hasOwnProperty(l) && (o[l] = void 0 === t[l] && void 0 !== c ? c[l] : t[l]);
      }
    }

    var l = arguments.length - 2;
    if (1 === l) o.children = n;else if (1 < l) {
      c = Array(l);

      for (var f = 0; f < l; f++) {
        c[f] = arguments[f + 2];
      }

      o.children = c;
    }
    return {
      $$typeof: a,
      type: e.type,
      key: i,
      ref: u,
      props: o,
      _owner: s
    };
  }, t.createContext = function (e, t) {
    return void 0 === t && (t = null), (e = {
      $$typeof: f,
      _calculateChangedBits: t,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }).Provider = {
      $$typeof: l,
      _context: e
    }, e.Consumer = e;
  }, t.createElement = x, t.createFactory = function (e) {
    var t = x.bind(null, e);
    return t.type = e, t;
  }, t.createRef = function () {
    return {
      current: null
    };
  }, t.forwardRef = function (e) {
    return {
      $$typeof: p,
      render: e
    };
  }, t.isValidElement = k, t.lazy = function (e) {
    return {
      $$typeof: h,
      _ctor: e,
      _status: -1,
      _result: null
    };
  }, t.memo = function (e, t) {
    return {
      $$typeof: y,
      type: e,
      compare: void 0 === t ? null : t
    };
  }, t.useCallback = function (e, t) {
    return M().useCallback(e, t);
  }, t.useContext = function (e, t) {
    return M().useContext(e, t);
  }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
    return M().useEffect(e, t);
  }, t.useImperativeHandle = function (e, t, n) {
    return M().useImperativeHandle(e, t, n);
  }, t.useLayoutEffect = function (e, t) {
    return M().useLayoutEffect(e, t);
  }, t.useMemo = function (e, t) {
    return M().useMemo(e, t);
  }, t.useReducer = function (e, t, n) {
    return M().useReducer(e, t, n);
  }, t.useRef = function (e) {
    return M().useRef(e);
  }, t.useState = function (e) {
    return M().useState(e);
  }, t.version = "16.13.1";
}, function (e, t, n) {
  "use strict";
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;

  function i(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  e.exports = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, u, s = i(e), c = 1; c < arguments.length; c++) {
      for (var l in n = Object(arguments[c])) {
        o.call(n, l) && (s[l] = n[l]);
      }

      if (r) {
        u = r(n);

        for (var f = 0; f < u.length; f++) {
          a.call(n, u[f]) && (s[u[f]] = n[u[f]]);
        }
      }
    }

    return s;
  };
}, function (e, t, n) {
  "use strict";

  var r = n(8);

  function o() {}

  function a() {}

  a.resetWarningCache = o, e.exports = function () {
    function e(e, t, n, o, a, i) {
      if (i !== r) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: a,
      resetWarningCache: o
    };
    return n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  n.r(t);

  var r = n(0),
      o = n.n(r),
      a = n(1),
      i = n.n(a),
      u = n(2),
      s = n.n(u),
      c = n(3),
      l = n.n(c),
      f = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      p = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  };

  function d(e) {
    return p({}, e, {
      playerVars: p({}, e.playerVars, {
        autoplay: 0,
        start: 0,
        end: 0
      })
    });
  }

  var y = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      return n.onPlayerReady = function (e) {
        return n.props.onReady(e);
      }, n.onPlayerError = function (e) {
        return n.props.onError(e);
      }, n.onPlayerStateChange = function (e) {
        switch (n.props.onStateChange(e), e.data) {
          case t.PlayerState.ENDED:
            n.props.onEnd(e);
            break;

          case t.PlayerState.PLAYING:
            n.props.onPlay(e);
            break;

          case t.PlayerState.PAUSED:
            n.props.onPause(e);
        }
      }, n.onPlayerPlaybackRateChange = function (e) {
        return n.props.onPlaybackRateChange(e);
      }, n.onPlayerPlaybackQualityChange = function (e) {
        return n.props.onPlaybackQualityChange(e);
      }, n.createPlayer = function () {
        if ("undefined" != typeof document) {
          var e = p({}, n.props.opts, {
            videoId: n.props.videoId
          });
          n.internalPlayer = l()(n.container, e), n.internalPlayer.on("ready", n.onPlayerReady), n.internalPlayer.on("error", n.onPlayerError), n.internalPlayer.on("stateChange", n.onPlayerStateChange), n.internalPlayer.on("playbackRateChange", n.onPlayerPlaybackRateChange), n.internalPlayer.on("playbackQualityChange", n.onPlayerPlaybackQualityChange);
        }
      }, n.resetPlayer = function () {
        return n.internalPlayer.destroy().then(n.createPlayer);
      }, n.updatePlayer = function () {
        n.internalPlayer.getIframe().then(function (e) {
          n.props.id ? e.setAttribute("id", n.props.id) : e.removeAttribute("id"), n.props.className ? e.setAttribute("class", n.props.className) : e.removeAttribute("class");
        });
      }, n.updateVideo = function () {
        if (void 0 !== n.props.videoId && null !== n.props.videoId) {
          var e = !1,
              t = {
            videoId: n.props.videoId
          };
          "playerVars" in n.props.opts && (e = 1 === n.props.opts.playerVars.autoplay, "start" in n.props.opts.playerVars && (t.startSeconds = n.props.opts.playerVars.start), "end" in n.props.opts.playerVars && (t.endSeconds = n.props.opts.playerVars.end)), e ? n.internalPlayer.loadVideoById(t) : n.internalPlayer.cueVideoById(t);
        } else n.internalPlayer.stopVideo();
      }, n.refContainer = function (e) {
        n.container = e;
      }, n.container = null, n.internalPlayer = null, n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, e), f(t, [{
      key: "componentDidMount",
      value: function value() {
        this.createPlayer();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        (function (e, t) {
          return e.id !== t.id || e.className !== t.className;
        })(e, this.props) && this.updatePlayer(), function (e, t) {
          return !s()(d(e.opts), d(t.opts));
        }(e, this.props) && this.resetPlayer(), function (e, t) {
          if (e.videoId !== t.videoId) return !0;
          var n = e.opts.playerVars || {},
              r = t.opts.playerVars || {};
          return n.start !== r.start || n.end !== r.end;
        }(e, this.props) && this.updateVideo();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.internalPlayer.destroy();
      }
    }, {
      key: "render",
      value: function value() {
        return i.a.createElement("div", {
          className: this.props.containerClassName
        }, i.a.createElement("div", {
          id: this.props.id,
          className: this.props.className,
          ref: this.refContainer
        }));
      }
    }]), t;
  }(i.a.Component);

  y.propTypes = {
    videoId: o.a.string,
    id: o.a.string,
    className: o.a.string,
    containerClassName: o.a.string,
    opts: o.a.objectOf(o.a.any),
    onReady: o.a.func,
    onError: o.a.func,
    onPlay: o.a.func,
    onPause: o.a.func,
    onEnd: o.a.func,
    onStateChange: o.a.func,
    onPlaybackRateChange: o.a.func,
    onPlaybackQualityChange: o.a.func
  }, y.defaultProps = {
    id: null,
    className: null,
    opts: {},
    containerClassName: "",
    onReady: function onReady() {},
    onError: function onError() {},
    onPlay: function onPlay() {},
    onPause: function onPause() {},
    onEnd: function onEnd() {},
    onStateChange: function onStateChange() {},
    onPlaybackRateChange: function onPlaybackRateChange() {},
    onPlaybackQualityChange: function onPlaybackQualityChange() {}
  }, y.PlayerState = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
  }, t.default = y;
}, function (e, t, n) {
  "use strict";

  var r;
  /**
  * @link https://github.com/gajus/sister for the canonical source repository
  * @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
  */

  r = function r() {
    var e = {},
        t = {};
    return e.on = function (e, n) {
      var r = {
        name: e,
        handler: n
      };
      return t[e] = t[e] || [], t[e].unshift(r), r;
    }, e.off = function (e) {
      var n = t[e.name].indexOf(e);
      -1 !== n && t[e.name].splice(n, 1);
    }, e.trigger = function (e, n) {
      var r,
          o = t[e];
      if (o) for (r = o.length; r--;) {
        o[r].handler(n);
      }
    }, e;
  }, e.exports = r;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
      o = n(12),
      a = (r = o) && r.__esModule ? r : {
    default: r
  };
  t.default = function (e) {
    return new Promise(function (t) {
      if (window.YT && window.YT.Player && window.YT.Player instanceof Function) t(window.YT);else {
        var n = "http:" === window.location.protocol ? "http:" : "https:";
        (0, a.default)(n + "//www.youtube.com/iframe_api", function (t) {
          t && e.trigger("error", t);
        });
        var r = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = function () {
          r && r(), t(window.YT);
        };
      }
    });
  }, e.exports = t.default;
}, function (e, t) {
  function n(e, t) {
    e.onload = function () {
      this.onerror = this.onload = null, t(null, e);
    }, e.onerror = function () {
      this.onerror = this.onload = null, t(new Error("Failed to load " + this.src), e);
    };
  }

  function r(e, t) {
    e.onreadystatechange = function () {
      "complete" != this.readyState && "loaded" != this.readyState || (this.onreadystatechange = null, t(null, e));
    };
  }

  e.exports = function (e, t, o) {
    var a = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("script");
    "function" == typeof t && (o = t, t = {}), t = t || {}, o = o || function () {}, i.type = t.type || "text/javascript", i.charset = t.charset || "utf8", i.async = !("async" in t) || !!t.async, i.src = e, t.attrs && function (e, t) {
      for (var n in t) {
        e.setAttribute(n, t[n]);
      }
    }(i, t.attrs), t.text && (i.text = "" + t.text), ("onload" in i ? n : r)(i, o), i.onload || n(i, o), a.appendChild(i);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = u(n(14)),
      o = u(n(18)),
      a = u(n(19)),
      i = u(n(20));

  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }

  var s = (0, r.default)("youtube-player"),
      c = {
    proxyEvents: function proxyEvents(e) {
      var t = {},
          n = function n(_n) {
        var r = "on" + _n.slice(0, 1).toUpperCase() + _n.slice(1);

        t[r] = function (t) {
          s('event "%s"', r, t), e.trigger(_n, t);
        };
      },
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var u, c = a.default[Symbol.iterator](); !(r = (u = c.next()).done); r = !0) {
          n(u.value);
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          !r && c.return && c.return();
        } finally {
          if (o) throw i;
        }
      }

      return t;
    },
    promisifyPlayer: function promisifyPlayer(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = {},
          r = function r(_r) {
        t && i.default[_r] ? n[_r] = function () {
          for (var t = arguments.length, n = Array(t), o = 0; o < t; o++) {
            n[o] = arguments[o];
          }

          return e.then(function (e) {
            var t = i.default[_r],
                o = e.getPlayerState(),
                a = e[_r].apply(e, n);

            return t.stateChangeRequired || Array.isArray(t.acceptableStates) && -1 === t.acceptableStates.indexOf(o) ? new Promise(function (n) {
              e.addEventListener("onStateChange", function r() {
                var o = e.getPlayerState(),
                    a = void 0;
                "number" == typeof t.timeout && (a = setTimeout(function () {
                  e.removeEventListener("onStateChange", r), n();
                }, t.timeout)), Array.isArray(t.acceptableStates) && -1 !== t.acceptableStates.indexOf(o) && (e.removeEventListener("onStateChange", r), clearTimeout(a), n());
              });
            }).then(function () {
              return a;
            }) : a;
          });
        } : n[_r] = function () {
          for (var t = arguments.length, n = Array(t), o = 0; o < t; o++) {
            n[o] = arguments[o];
          }

          return e.then(function (e) {
            return e[_r].apply(e, n);
          });
        };
      },
          a = !0,
          u = !1,
          s = void 0;

      try {
        for (var c, l = o.default[Symbol.iterator](); !(a = (c = l.next()).done); a = !0) {
          var f = c.value;
          r(f);
        }
      } catch (e) {
        u = !0, s = e;
      } finally {
        try {
          !a && l.return && l.return();
        } finally {
          if (u) throw s;
        }
      }

      return n;
    }
  };
  t.default = c, e.exports = t.default;
}, function (e, t, n) {
  (function (r) {
    function o() {
      var e;

      try {
        e = t.storage.debug;
      } catch (e) {}

      return !e && void 0 !== r && "env" in r && (e = r.env.DEBUG), e;
    }

    (t = e.exports = n(16)).log = function () {
      return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }, t.formatArgs = function (e) {
      var n = this.useColors;
      if (e[0] = (n ? "%c" : "") + this.namespace + (n ? " %c" : " ") + e[0] + (n ? "%c " : " ") + "+" + t.humanize(this.diff), !n) return;
      var r = "color: " + this.color;
      e.splice(1, 0, r, "color: inherit");
      var o = 0,
          a = 0;
      e[0].replace(/%[a-zA-Z%]/g, function (e) {
        "%%" !== e && (o++, "%c" === e && (a = o));
      }), e.splice(a, 0, r);
    }, t.save = function (e) {
      try {
        null == e ? t.storage.removeItem("debug") : t.storage.debug = e;
      } catch (e) {}
    }, t.load = o, t.useColors = function () {
      if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return !0;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, t.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function () {
      try {
        return window.localStorage;
      } catch (e) {}
    }(), t.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"], t.formatters.j = function (e) {
      try {
        return JSON.stringify(e);
      } catch (e) {
        return "[UnexpectedJSONParseError]: " + e.message;
      }
    }, t.enable(o());
  }).call(this, n(15));
}, function (e, t) {
  var n,
      r,
      o = e.exports = {};

  function a() {
    throw new Error("setTimeout has not been defined");
  }

  function i() {
    throw new Error("clearTimeout has not been defined");
  }

  function u(e) {
    if (n === setTimeout) return setTimeout(e, 0);
    if ((n === a || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

    try {
      return n(e, 0);
    } catch (t) {
      try {
        return n.call(null, e, 0);
      } catch (t) {
        return n.call(this, e, 0);
      }
    }
  }

  !function () {
    try {
      n = "function" == typeof setTimeout ? setTimeout : a;
    } catch (e) {
      n = a;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : i;
    } catch (e) {
      r = i;
    }
  }();
  var s,
      c = [],
      l = !1,
      f = -1;

  function p() {
    l && s && (l = !1, s.length ? c = s.concat(c) : f = -1, c.length && d());
  }

  function d() {
    if (!l) {
      var e = u(p);
      l = !0;

      for (var t = c.length; t;) {
        for (s = c, c = []; ++f < t;) {
          s && s[f].run();
        }

        f = -1, t = c.length;
      }

      s = null, l = !1, function (e) {
        if (r === clearTimeout) return clearTimeout(e);
        if ((r === i || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

        try {
          r(e);
        } catch (t) {
          try {
            return r.call(null, e);
          } catch (t) {
            return r.call(this, e);
          }
        }
      }(e);
    }
  }

  function y(e, t) {
    this.fun = e, this.array = t;
  }

  function h() {}

  o.nextTick = function (e) {
    var t = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      t[n - 1] = arguments[n];
    }
    c.push(new y(e, t)), 1 !== c.length || l || u(d);
  }, y.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = h, o.addListener = h, o.once = h, o.off = h, o.removeListener = h, o.removeAllListeners = h, o.emit = h, o.prependListener = h, o.prependOnceListener = h, o.listeners = function (e) {
    return [];
  }, o.binding = function (e) {
    throw new Error("process.binding is not supported");
  }, o.cwd = function () {
    return "/";
  }, o.chdir = function (e) {
    throw new Error("process.chdir is not supported");
  }, o.umask = function () {
    return 0;
  };
}, function (e, t, n) {
  var r;

  function o(e) {
    function n() {
      if (n.enabled) {
        var e = n,
            o = +new Date(),
            a = o - (r || o);
        e.diff = a, e.prev = r, e.curr = o, r = o;

        for (var i = new Array(arguments.length), u = 0; u < i.length; u++) {
          i[u] = arguments[u];
        }

        i[0] = t.coerce(i[0]), "string" != typeof i[0] && i.unshift("%O");
        var s = 0;
        i[0] = i[0].replace(/%([a-zA-Z%])/g, function (n, r) {
          if ("%%" === n) return n;
          s++;
          var o = t.formatters[r];

          if ("function" == typeof o) {
            var a = i[s];
            n = o.call(e, a), i.splice(s, 1), s--;
          }

          return n;
        }), t.formatArgs.call(e, i);
        var c = n.log || t.log || console.log.bind(console);
        c.apply(e, i);
      }
    }

    return n.namespace = e, n.enabled = t.enabled(e), n.useColors = t.useColors(), n.color = function (e) {
      var n,
          r = 0;

      for (n in e) {
        r = (r << 5) - r + e.charCodeAt(n), r |= 0;
      }

      return t.colors[Math.abs(r) % t.colors.length];
    }(e), "function" == typeof t.init && t.init(n), n;
  }

  (t = e.exports = o.debug = o.default = o).coerce = function (e) {
    return e instanceof Error ? e.stack || e.message : e;
  }, t.disable = function () {
    t.enable("");
  }, t.enable = function (e) {
    t.save(e), t.names = [], t.skips = [];

    for (var n = ("string" == typeof e ? e : "").split(/[\s,]+/), r = n.length, o = 0; o < r; o++) {
      n[o] && ("-" === (e = n[o].replace(/\*/g, ".*?"))[0] ? t.skips.push(new RegExp("^" + e.substr(1) + "$")) : t.names.push(new RegExp("^" + e + "$")));
    }
  }, t.enabled = function (e) {
    var n, r;

    for (n = 0, r = t.skips.length; n < r; n++) {
      if (t.skips[n].test(e)) return !1;
    }

    for (n = 0, r = t.names.length; n < r; n++) {
      if (t.names[n].test(e)) return !0;
    }

    return !1;
  }, t.humanize = n(17), t.names = [], t.skips = [], t.formatters = {};
}, function (e, t) {
  var n = 1e3,
      r = 6e4,
      o = 60 * r,
      a = 24 * o;

  function i(e, t, n) {
    if (!(e < t)) return e < 1.5 * t ? Math.floor(e / t) + " " + n : Math.ceil(e / t) + " " + n + "s";
  }

  e.exports = function (e, t) {
    t = t || {};
    var u,
        s = typeof e;
    if ("string" === s && e.length > 0) return function (e) {
      if ((e = String(e)).length > 100) return;
      var t = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);
      if (!t) return;
      var i = parseFloat(t[1]);

      switch ((t[2] || "ms").toLowerCase()) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return 315576e5 * i;

        case "days":
        case "day":
        case "d":
          return i * a;

        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return i * o;

        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return i * r;

        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return i * n;

        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return i;

        default:
          return;
      }
    }(e);
    if ("number" === s && !1 === isNaN(e)) return t.long ? i(u = e, a, "day") || i(u, o, "hour") || i(u, r, "minute") || i(u, n, "second") || u + " ms" : function (e) {
      if (e >= a) return Math.round(e / a) + "d";
      if (e >= o) return Math.round(e / o) + "h";
      if (e >= r) return Math.round(e / r) + "m";
      if (e >= n) return Math.round(e / n) + "s";
      return e + "ms";
    }(e);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = ["cueVideoById", "loadVideoById", "cueVideoByUrl", "loadVideoByUrl", "playVideo", "pauseVideo", "stopVideo", "getVideoLoadedFraction", "cuePlaylist", "loadPlaylist", "nextVideo", "previousVideo", "playVideoAt", "setShuffle", "setLoop", "getPlaylist", "getPlaylistIndex", "setOption", "mute", "unMute", "isMuted", "setVolume", "getVolume", "seekTo", "getPlayerState", "getPlaybackRate", "setPlaybackRate", "getAvailablePlaybackRates", "getPlaybackQuality", "setPlaybackQuality", "getAvailableQualityLevels", "getCurrentTime", "getDuration", "removeEventListener", "getVideoUrl", "getVideoEmbedCode", "getOptions", "getOption", "addEventListener", "destroy", "setSize", "getIframe"], e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = ["ready", "stateChange", "playbackQualityChange", "playbackRateChange", "error", "apiChange", "volumeChange"], e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r,
      o = n(21),
      a = (r = o) && r.__esModule ? r : {
    default: r
  };
  t.default = {
    pauseVideo: {
      acceptableStates: [a.default.ENDED, a.default.PAUSED],
      stateChangeRequired: !1
    },
    playVideo: {
      acceptableStates: [a.default.ENDED, a.default.PLAYING],
      stateChangeRequired: !1
    },
    seekTo: {
      acceptableStates: [a.default.ENDED, a.default.PLAYING, a.default.PAUSED],
      stateChangeRequired: !0,
      timeout: 3e3
    }
  }, e.exports = t.default;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
  }, e.exports = t.default;
}, function (e, t, n) {
  var r = n(23);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(25)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, t, n) {
  (t = n(24)(!1)).push([e.i, ".Player__container___f3NHe{\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.Player__videoContainer___2TVqS{\n\tposition: absolute;\n\tleft:0;\n\ttop:0;\n\tright:0;\n\tbottom:0;\n\twidth:100%;\n\theight:100%;\n\tz-index: -1;\n\n}\n\n.Player__videoInnerContainer___3idnr{\n\twidth:100%;\n\theight:100%;\n}\n\n.Player__overlay___3alO1{\n\tposition: absolute;\n\tleft:0;\n\ttop:0;\n\tright:0;\n\tbottom:0;\n\tz-index: 5\n}\n.Player__videoIframe___3_jFK{\n\tposition: relative;\n\tleft:0;\n\ttop:0;\n\tright:0;\n\tbottom:0;\n\twidth: 100%;\n\theight: 100%;\n\tz-index:0;\n\n}", ""]), t.locals = {
    container: "Player__container___f3NHe",
    videoContainer: "Player__videoContainer___2TVqS",
    videoInnerContainer: "Player__videoInnerContainer___3idnr",
    overlay: "Player__overlay___3alO1",
    videoIframe: "Player__videoIframe___3_jFK"
  }, e.exports = t;
}, function (e, t, n) {
  "use strict";

  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var n = function (e, t) {
          var n = e[1] || "",
              r = e[3];
          if (!r) return n;

          if (t && "function" == typeof btoa) {
            var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), s = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(s, " */")),
                a = r.sources.map(function (e) {
              return "/*# sourceURL=".concat(r.sourceRoot || "").concat(e, " */");
            });
            return [n].concat(a).concat([o]).join("\n");
          }

          var i, u, s;
          return [n].join("\n");
        }(t, e);

        return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
      }).join("");
    }, t.i = function (e, n, r) {
      "string" == typeof e && (e = [[null, e, ""]]);
      var o = {};
      if (r) for (var a = 0; a < this.length; a++) {
        var i = this[a][0];
        null != i && (o[i] = !0);
      }

      for (var u = 0; u < e.length; u++) {
        var s = [].concat(e[u]);
        r && o[s[0]] || (n && (s[2] ? s[2] = "".concat(n, " and ").concat(s[2]) : s[2] = n), t.push(s));
      }
    }, t;
  };
}, function (e, t, n) {
  var r,
      o,
      a = {},
      i = (r = function r() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = r.apply(this, arguments)), o;
  }),
      u = function u(e) {
    return document.querySelector(e);
  },
      s = function (e) {
    var t = {};
    return function (e) {
      if ("function" == typeof e) return e();

      if (void 0 === t[e]) {
        var n = u.call(this, e);
        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
          n = n.contentDocument.head;
        } catch (e) {
          n = null;
        }
        t[e] = n;
      }

      return t[e];
    };
  }(),
      c = null,
      l = 0,
      f = [],
      p = n(26);

  function d(e, t) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n],
          o = a[r.id];

      if (o) {
        o.refs++;

        for (var i = 0; i < o.parts.length; i++) {
          o.parts[i](r.parts[i]);
        }

        for (; i < r.parts.length; i++) {
          o.parts.push(g(r.parts[i], t));
        }
      } else {
        var u = [];

        for (i = 0; i < r.parts.length; i++) {
          u.push(g(r.parts[i], t));
        }

        a[r.id] = {
          id: r.id,
          refs: 1,
          parts: u
        };
      }
    }
  }

  function y(e, t) {
    for (var n = [], r = {}, o = 0; o < e.length; o++) {
      var a = e[o],
          i = t.base ? a[0] + t.base : a[0],
          u = {
        css: a[1],
        media: a[2],
        sourceMap: a[3]
      };
      r[i] ? r[i].parts.push(u) : n.push(r[i] = {
        id: i,
        parts: [u]
      });
    }

    return n;
  }

  function h(e, t) {
    var n = s(e.insertInto);
    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var r = f[f.length - 1];
    if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), f.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = s(e.insertInto + " " + e.insertAt.before);
      n.insertBefore(t, o);
    }
  }

  function v(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var t = f.indexOf(e);
    t >= 0 && f.splice(t, 1);
  }

  function m(e) {
    var t = document.createElement("style");
    return void 0 === e.attrs.type && (e.attrs.type = "text/css"), b(t, e.attrs), h(e, t), t;
  }

  function b(e, t) {
    Object.keys(t).forEach(function (n) {
      e.setAttribute(n, t[n]);
    });
  }

  function g(e, t) {
    var n, r, o, a;

    if (t.transform && e.css) {
      if (!(a = t.transform(e.css))) return function () {};
      e.css = a;
    }

    if (t.singleton) {
      var i = l++;
      n = c || (c = m(t)), r = _.bind(null, n, i, !1), o = _.bind(null, n, i, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
      var t = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", b(t, e.attrs), h(e, t), t;
    }(t), r = S.bind(null, n, t), o = function o() {
      v(n), n.href && URL.revokeObjectURL(n.href);
    }) : (n = m(t), r = E.bind(null, n), o = function o() {
      v(n);
    });

    return r(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        r(e = t);
      } else o();
    };
  }

  e.exports = function (e, t) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
    var n = y(e, t);
    return d(n, t), function (e) {
      for (var r = [], o = 0; o < n.length; o++) {
        var i = n[o];
        (u = a[i.id]).refs--, r.push(u);
      }

      e && d(y(e, t), t);

      for (o = 0; o < r.length; o++) {
        var u;

        if (0 === (u = r[o]).refs) {
          for (var s = 0; s < u.parts.length; s++) {
            u.parts[s]();
          }

          delete a[u.id];
        }
      }
    };
  };

  var w,
      P = (w = [], function (e, t) {
    return w[e] = t, w.filter(Boolean).join("\n");
  });

  function _(e, t, n, r) {
    var o = n ? "" : r.css;
    if (e.styleSheet) e.styleSheet.cssText = P(t, o);else {
      var a = document.createTextNode(o),
          i = e.childNodes;
      i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
    }
  }

  function E(e, t) {
    var n = t.css,
        r = t.media;
    if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(n));
    }
  }

  function S(e, t, n) {
    var r = n.css,
        o = n.sourceMap,
        a = void 0 === t.convertToAbsoluteUrls && o;
    (t.convertToAbsoluteUrls || a) && (r = p(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
    var i = new Blob([r], {
      type: "text/css"
    }),
        u = e.href;
    e.href = URL.createObjectURL(i), u && URL.revokeObjectURL(u);
  }
}, function (e, t) {
  e.exports = function (e) {
    var t = "undefined" != typeof window && window.location;
    if (!t) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var n = t.protocol + "//" + t.host,
        r = n + t.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
      var o,
          a = t.trim().replace(/^"(.*)"$/, function (e, t) {
        return t;
      }).replace(/^'(.*)'$/, function (e, t) {
        return t;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? n + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}]);